var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcehockey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3 72 83.98 0h11.998S64.82 68.76 55.018 91.239l-.02.051A8 8 0 0 1 47.705 96H20.179l6.562-19.521h13.485c3.09-.042 5.757-1.836 7.074-4.479M.26 90.639l3.72-9.24h.003l.018-.054a8 8 0 0 1 7.38-4.947h7.12l-6.52 19.599h-8a4 4 0 0 1-3.72-5.358M10.38 56.96c5 3.24 15.998 4.32 24.6 2.481 5.76-1.239 9-3.441 9-5.841v-7.16c-2.11 1.056-4.558 1.911-7.123 2.445l-.198.036c-3.126.687-6.72 1.08-10.4 1.08h-.28a43.1 43.1 0 0 1-18-3.587v-.01l-.276-.111.276.121v7.19a4.2 4.2 0 0 0 2.376 3.348l.024.012zM25.981 42c9.897 0 17.919-3.027 17.919-6.76 0-3.731-8.023-6.758-17.92-6.758S8.064 31.509 8.064 35.24 16.084 42 25.982 42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcehockey);
export default __webpack_public_path__ + "static/media/icehockey.772a6a7cc6c7ef78eafa59e5dbaf0c20.svg";
export { ForwardRef as ReactComponent };